import OptionModal from './OptionModal.view';

export default OptionModal;
